// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Zard from './Zard';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: 'App',
  router,
  store,
  template: '<Zard/>',
  components: { Zard },
});



// WEBPACK FOOTER //
// ./src/main.js